import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MasterDetailListShell from "../../../components/layout/MasterDetailListShell";
import MasterDetailRow from "../../../components/layout/MasterDetailRow";
import { useGetUpcomingDeploymentsQuery } from "../guardingApi";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { paths } from "../../../routes/paths";
import { dateOnly, requestKey } from "../pendingRequest";

// One row per deployment REQUEST - an order's lines sharing a start date and a
// guard service - so the same order can be listed more than once (see
// pendingRequest.js). The guard count is what is still to deploy in that
// request, not the order's total.
const PendingDeploymentCompactList = () => {
  const navigate = useNavigate();
  const { recordGuid: selectedRecordGuid } = useParams();
  const [searchParams] = useSearchParams();
  const selectedKey = selectedRecordGuid
    ? `${selectedRecordGuid}|${searchParams.get("date") || ""}|${searchParams.get("service") || ""}`
    : null;
  const { selectedBranchId } = useBranchFilter();

  const { data: rows = [], isLoading } = useGetUpcomingDeploymentsQuery({ branchId: selectedBranchId ?? undefined });

  return (
    <MasterDetailListShell
      title="Pending Deployments"
      isLoading={isLoading}
      emptyLabel="No confirmed orders are waiting on a guard deployment."
      items={rows}
      getKey={requestKey}
      resetKey={String(selectedBranchId)}
      renderItem={(r) => {
        const isSelected = requestKey(r).toLowerCase() === (selectedKey || "").toLowerCase();
        return (
          <MasterDetailRow
            isSelected={isSelected}
            onClick={() =>
              navigate(
                paths.guardingPendingDeploymentDetail(r.recordGuid, {
                  date: dateOnly(r.requestedDeploymentDate),
                  serviceTypeId: r.serviceTypeId,
                })
              )
            }
            avatarLabel={(r.customerName || "?").trim().slice(0, 2).toUpperCase()}
            title={
              // Customer leads, order number is the detail line (2026-09-12).
              <>
                {r.customerName || r.orderNumber} <span className="text-muted ms-1">{r.guardsCount} guard{r.guardsCount === 1 ? "" : "s"}</span>
              </>
            }
            subtitle={
              <>
                {r.orderNumber} &middot; {r.branchCode}
                {r.serviceTypeName ? ` · ${r.serviceTypeName}` : ""}
                {r.area ? ` · ${r.area}` : ""}
              </>
            }
            badge={
              !r.requestedDeploymentDate ? (
                <span className="badge badge-linewarning me-2">Date not set</span>
              ) : (
                <span className="badge badge-lineinfo me-2">{new Date(r.requestedDeploymentDate).toLocaleDateString()}</span>
              )
            }
          />
        );
      }}
    />
  );
};

export default PendingDeploymentCompactList;
